import {Route} from "react-router";
import {RequireAuth} from "../authentication/routing/RequireAuth";
import {ChatLayout} from "../pages/chat-agent/ChatLayout";
import {ChatPage} from "../pages/chat-agent/ChatPage";
import {ChatDashboardsPage} from "../pages/chat-agent/ChatDashboardsPage";
import {routes} from "./routes";

/** Nested chat layout: sidebar stays mounted across chat / dashboards. */
export const chatRoute = (
    <Route path={routes.chat} element={<RequireAuth><ChatLayout/></RequireAuth>}>
        <Route index element={<ChatPage/>}/>
        <Route path="dashboards" element={<ChatDashboardsPage/>}/>
    </Route>
);
